import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import ServiceDetail from './pages/ServiceDetail';
import Contact from './pages/Contact';
import './index.css';

function Layout({ children }) {
  return (
    <>
      <Header />
      {children}
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/"               element={<Layout><Home /></Layout>} />
        <Route path="/about"          element={<Layout><About /></Layout>} />
        <Route path="/services"       element={<Layout><Services /></Layout>} />
        <Route path="/services/:id"   element={<Layout><ServiceDetail /></Layout>} />
        <Route path="/contact"        element={<Layout><Contact /></Layout>} />
        <Route path="*"               element={<Layout><Home /></Layout>} />
      </Routes>
    </BrowserRouter>
  );
}
